export function duplicateArrayItems(arr, times) {
    return Array.from({ length: times }, () => arr).reduce((acc, curr) => acc.concat(curr), []);
}
